import { render, staticRenderFns } from "./cityTeam.vue?vue&type=template&id=205aa507&scoped=true&"
import script from "./cityTeam.vue?vue&type=script&lang=js&"
export * from "./cityTeam.vue?vue&type=script&lang=js&"
import style0 from "./cityTeam.vue?vue&type=style&index=0&id=205aa507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205aa507",
  null
  
)

export default component.exports